export class MapState {
  static key = "map_state";

  static save(bounds, depotIdSelected, depotIdsFocused) {
    sessionStorage.setItem(
      MapState.key,
      JSON.stringify({
        bounds: bounds,
        depot_id_selected: depotIdSelected,
        depot_ids_focused: depotIdsFocused
      })
    );
  }

  static load() {
    let state = sessionStorage.getItem(MapState.key);

    if (!state) return;

    state = JSON.parse(state);
    state = {
      ...state,
      depot_id_selected: state.depot_id_selected,
      depot_ids_focused: state.depot_ids_focused
    };

    return state;
  }

  static clear() {
    return sessionStorage.removeItem(MapState.key);
  }
}
